import {
  serializeObject,
  getBrowserCore,
  axiosClient,
  isProd,
  initI18n,
} from 'www/utils'
import Modal from 'www/modules/Modal/index'
import YaGoals from 'www/modules/YandexGoals'

function getTemplate(i18next) {
  const gratitudesNode = document.querySelector('.b-gratitudes')
  const agreementLink = gratitudesNode.getAttribute('data-agreement-link')
  const deviceType = gratitudesNode.getAttribute('data-device-type')

  const headerTemplate = `<p class="text-h6 text--text mb-6">${i18next.t('Благодарность врачу', { ns: i18next.language })}</p>
                              <button class="b-gratitudes__close ui-icon-close-not-a-circle text-secondary--text" type="button"></button>`

  return `<div class="b-gratitudes__container mr-0">
                  ${deviceType === 'mobile' ? '' : headerTemplate}
                  <dl class="b-gratitudes__faq">
                      <dt class="text-subtitle-1 text--text">
                        ${i18next.t('Для чего это?', { ns: i18next.language })}
                      </dt>
                      <dd class="b-gratitudes__answer text-body-1 text--text">
                          ${i18next.t('На случай если вы желаете поблагодарить врача за лечение, но не хотите дарить деньги лично.', { ns: i18next.language })}
                      </dd>
                      <dt class="text-subtitle-1 text--text">
                        ${i18next.t('Как это работает?', { ns: i18next.language })}
                      </dt>
                      <dd class="b-gratitudes__answer text-body-1 text--text">
                          ${i18next.t('Деньги отправляются на личный счёт врача. Клиника здесь не участвует.', { ns: i18next.language })}
                      </dd>
                      <dt class="text-subtitle-1 text--text">
                        ${i18next.t('Врач не будет против?', { ns: i18next.language })}
                      </dt>
                      <dd class="b-gratitudes__answer text-body-1 text--text">
                          ${i18next.t('Нет. Врач разрешил добавить «благодарность» на свою страницу.', { ns: i18next.language })}
                      </dd>
                      <dt class="text-subtitle-1 text--text">
                        ${i18next.t('ПроДокторов берёт себе процент?', { ns: i18next.language })}
                      </dt>
                      <dd class="b-gratitudes__answer text-body-1 text--text">
                          ${i18next.t('Нет. Мы отправляем врачу ту сумму, которую вы указываете. Процент за использование сервиса может снимать сама платёжная система.', { ns: i18next.language })}
                      </dd>
                  </dl>

                  <span class="b-gratitudes__description text-body-2 text-secondary--text mb-6">
                      ${i18next.t('Отправляя благодарность врачу, вы принимаете', { ns: i18next.language })}
                      <a href="${agreementLink}"
                         class="primary--text" target="_blank"
                      >${i18next.t('условия использования', { ns: i18next.language })}</a>.
                  </span>
                  <div
                    id="pay-btn"
                    class="b-gratitudes__pay-button b-button b-button_blue"
                   >
                    <span class="text-button bg-gray-0--text">
                       ${i18next.t('Поблагодарить', { ns: i18next.language })}
                    </span>
                  </div>
                </div>
            `
}

function isOldBrowserVersion() {
  const agent = navigator.userAgent
  const iphone = agent.match(/iPhone OS (?<version>\d\d)/)
  const isOldIphone = iphone ? iphone.groups.version < 13 : false
  const isOldBrowser = getBrowserCore() === 'trident'

  return isOldIphone || isOldBrowser
}

function getRequestData() {
  const paymentLink = document.getElementById('payment-link')

  if (!paymentLink) {
    return
  }

  const url = paymentLink.dataset.request
  const csrfToken = paymentLink.dataset.csrf

  if (!url || !csrfToken) {
    return
  }

  const csrfData = serializeObject({
    csrfmiddlewaretoken: csrfToken,
  })

  return {
    url,
    csrfData,
  }
}

function pay(layoutId) {
  try {
    // eslint-disable-next-line no-undef
    const widget = new ctips.CloudTipsSiteWidget()

    widget.open({
      layoutid: layoutId, // id страницы оплаты
    }, {})
  } catch { /* Empty */ }
}

async function requestLayoutId(requestData) {
  try {
    const { url, csrfData } = requestData
    const { data } = await axiosClient.post(url, csrfData)

    return data.layout_id
  } catch { /* Empty */ }
}

async function initModal() {
  const { i18next } = await initI18n({ bundle: 'doctors.blocks/common/b-gratitudes' })
  const gratitudesNode = document.querySelector('.b-gratitudes')

  if (!gratitudesNode) {
    return
  }

  if (isOldBrowserVersion()) {
    gratitudesNode.style.display = 'none'
    return
  }

  new Modal({
    id: 'gratitudes-modal',
    mobileTitle: `${i18next.t('Благодарность врачу', { ns: i18next.language })}`,
    catchEventShow: ['.b-gratitudes__button'],
    catchEventHide: ['.b-gratitudes__close'],
    bodyClassList: 'b-gratitudes b-gratitudes_padding',
    beforeShow: async ({ open, render }) => {
      render({ template: getTemplate(i18next) })
      open()

      const requestData = getRequestData()
      const layoutId = await requestLayoutId(requestData)

      document.getElementById('pay-btn').addEventListener('click', () => pay(layoutId))
    },
  })
}

const head = document.querySelector('head')
const widgetScript = document.createElement('script')

widgetScript.src = isProd
  ? 'https://widget.cloudtips.ru/bundle.js'
  : 'https://widget-sandbox.cloudtips.ru/bundle.js'
widgetScript.setAttribute('async', 'true')

head.appendChild(widgetScript)

widgetScript.onload = () => {
  initModal()
}

// Яндекс метрика
new YaGoals({
  dataName: 'data-ya-goals-gratitude',
})
